import React from "react";
import styles from "./styles.module.scss";
import Bebel from "../../../assets/images/bebel.gif";

const ErrorScreen: React.FC = () => {
  return (
    <div className={styles.error}>
      <h3>Código promocional inválido!</h3>
      <p>Verifique seu e-mail e tente novamente mais tarde.</p>
      <img src={Bebel} alt="bebel" />
    </div>
  );
};

export default ErrorScreen;
